import { lazy, Suspense } from 'react';
import { mockedResult } from './demoAssets';

const Model360Viewer = lazy(() => import('./Model360Viewer'));

function ResultPage({ onReset }) {
  return (
    <main className="result-page">
      <section className="viewer-result" aria-labelledby="viewer-title">
        <div className="viewer-copy">
          <p className="eyebrow">Interactive GLB output</p>
          <h1 id="viewer-title">Interactive 3D Model Viewer</h1>
          <p>
            The sample image has been converted through the mocked flow. The
            provided local GLB model is now loaded in a real orbit viewer.
          </p>
        </div>

        <Suspense
          fallback={
            <div className="model-viewer-shell model-suspense" role="status">
              Preparing interactive viewer...
            </div>
          }
        >
          <Model360Viewer modelUrl={mockedResult.modelUrl} />
        </Suspense>

        <button className="button primary-button upload-another" type="button" onClick={onReset}>
          Start Again
        </button>
      </section>
    </main>
  );
}

export default ResultPage;
